import React from 'react'
import Link from 'gatsby-link'
import './footer.css'

// -- Stateless Component
const Footer = () => (
  <footer className="Footer">
    <div className="FooterGroup">
      <p>&copy; Gloria Ngo 2018</p>
      <p className="Credit">Background image for Hero was by Tim Gouw on Unsplash</p>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js